import api from '@/api'
import { formatDate } from '@/utils'

const emptyArticle = {
  title: '',
  summary: '',
  keywords: [],
  content: ''
}
const articleStore = {
  state: {
    stats: {
      aiPublishArticleCount: 0,
      publishArticleCount: 0,
      pendingAuditArticleCount: 0,
      auditRejectArticleCount: 0,
      draftArticleCount: 0,
      indexArticleCount: 0
    },
    chartData: {
      series: [],
      tooltip: {}
    },
    detail: {
      total: 0,
      list: [
        // {
        //   id: 1,
        //   title: '标题',
        //   publishOrigin: 5,
        //   publishTime: 1533892461
        // }
      ]
    },
    newestHitArticle: {
      total: 0,
      list: []
    },
    newestPublishArticle: {
      total: 0,
      list: []
    },
    newestIndexArticle: {
      total: 0,
      list: []
    },
    publishArticle: {
      total: 0,
      list: []
    },
    pendingAuditArticle: {
      total: 0,
      list: []
    },
    auditRejectArticle: {
      total: 0,
      list: []
    },
    draftArticle: {
      total: 0,
      list: []
    },
    currentArticle: { ...emptyArticle }
  },

  mutations: {
    SET_ARTICLE_STATS (state, { stats }) {
      state.stats.aiPublishArticleCount = stats.aiPublishArticleCount
      state.stats.publishArticleCount = stats.publishArticleCount
      state.stats.pendingAuditArticleCount = stats.pendingAuditArticleCount
      state.stats.auditRejectArticleCount = stats.auditRejectArticleCount
      state.stats.draftArticleCount = stats.draftArticleCount
      state.stats.indexArticleCount = stats.indexArticleCount
    },

    SET_ARTICLES_CHART_DATA (state, { chartData }) {
      state.chartData.series = chartData.series
    },

    SET_ARTICLES_DETAIL (state, { total, articles }) {
      state.detail.total = total
      state.detail.list = articles
    },

    SET_ARTICLES (state, { status, total, articles }) {
      switch (status) {
        case 0: // 草稿
          state.draftArticle.total = total
          state.draftArticle.list = articles
          break

        case 1: // 待审核
          state.pendingAuditArticle.total = total
          state.pendingAuditArticle.list = articles
          break

        case 3: // 审核驳回
          state.auditRejectArticle.total = total
          state.auditRejectArticle.list = articles
          break

        case 5: // 发布成功
          state.publishArticle.total = total
          state.publishArticle.list = articles
          break

        default:
          // no handler
          break
      }
    },

    SET_NEWEST_HIT_ARTICLE (state, { total, articles }) {
      state.newestHitArticle.total = total
      state.newestHitArticle.list = articles
    },

    SET_NEWEST_PUBLISH_ARTICLE (state, { total, articles }) {
      state.newestPublishArticle.total = total
      state.newestPublishArticle.list = articles
    },

    SET_NEWEST_INDEX_ARTICLE (state, { total, articles }) {
      state.newestIndexArticle.total = total
      state.newestIndexArticle.list = articles
    },

    SET_CURRENT_ARTICLE (state, { article = { ...emptyArticle } }) {
      state.currentArticle = article
    }
  },

  actions: {
    getArticlesStats ({ commit }, data) {
      return api.article.getArticlesStats(data).then(response => {
        const { stats } = response.data

        commit('SET_ARTICLE_STATS', { stats })
        return response
      })
    },

    getArticleChartData ({ commit }, data) {
      return api.stats.getUserPublishTrend(data).then(response => {
        const data = response.data.results.trend
        const line = {
          name: '总发布量',
          type: 'line',
          data: [],
          itemStyle: {
            normal: {
              color: '#2a85ff',
              lineStyle: {
                color: '#2a85ff',
                width: 2
              }
            }
          }
        }

        data.forEach(item => {
          const date = formatDate(item.date, 'YYYY-MM-DD', 's')
          const publishCount = item.publish_article_count

          line.data.push([ date, publishCount ])
        })

        commit('SET_ARTICLES_CHART_DATA', {
          chartData: {
            series: [ line ]
          }
        })

        return response
      })
    },

    getArticleDetails ({ commit }, data) {
      return api.article.getArticles(data).then(response => {
        const total = response.data.total || 0
        const articles = response.data.articles || []

        commit('SET_ARTICLES_DETAIL', {
          total,
          articles: articles.map(item => ({
            id: item.id,
            title: item.title,
            publishOrigin: item.status,
            publishTime: item.publishTime
          }))
        })

        return response
      })
    },

    getArticles ({ commit }, data) {
      return api.article.getArticles(data).then(response => {
        const { total, articles: originalArticles } = response.data
        const articles = originalArticles.map(item => {
          const lastAuditRecord = item.lastAuditRecord || {}

          return {
            id: item.id,
            userId: item.ownerUid,
            title: item.title,
            isAuditReject: lastAuditRecord.operation === 'reject',
            auditMessage: lastAuditRecord.message,
            time: item.createdAt || 0
          }
        })
        commit('SET_ARTICLES', { total, articles, status: data.query.status[0] })
        return response
      })
    },

    getNewsetHitArticles ({ commit }, data) {
      return api.article.getArticles(data).then(response => {
        const { total, articles: originalArticles } = response.data
        const articles = originalArticles.map(item => ({
          id: item.id,
          userId: item.ownerUid,
          title: item.title,
          isAuditReject: false,
          auditMessage: '',
          time: item.lastClickTime || 0
        }))
        commit('SET_NEWEST_HIT_ARTICLE', { total, articles })
        return response
      })
    },

    getNewsetPublishArticles ({ commit }, data) {
      return api.article.getArticles(data).then(response => {
        const { total, articles: originalArticles } = response.data
        const articles = originalArticles.map(item => ({
          id: item.id,
          userId: item.ownerUid,
          title: item.title,
          isAuditReject: false,
          auditMessage: '',
          time: item.publishTime || 0
        }))
        commit('SET_NEWEST_PUBLISH_ARTICLE', { total, articles })
        return response
      })
    },

    getNewsetIndexArticles ({ commit }, data) {
      return api.article.getArticles(data).then(response => {
        const { total, articles: originalArticles } = response.data
        const articles = originalArticles.map(item => ({
          id: item.id,
          userId: item.ownerUid,
          title: item.title,
          isAuditReject: false,
          auditMessage: '',
          time: item.indexTime || 0
        }))
        commit('SET_NEWEST_INDEX_ARTICLE', { total, articles })
        return response
      })
    },

    getArticleById ({ commit }, data) {
      return api.article.getArticleById(data).then(response => {
        commit('SET_CURRENT_ARTICLE', response.data)
        return response
      })
    },

    createArticle ({ commit }, data) {
      return api.article.createArticle(data)
    },

    deleteArticle ({ commit }, data) {
      return api.article.deleteArticle(data)
    },

    updateArticle ({ commit }, data) {
      return api.article.updateArticle(data)
    }
  }
}

export default articleStore
